import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function CaseGeneratedFormsRoute() {
  return <AdminOperationsScreen screenIdOverride="generated-forms" />;
}
